export const GA_SECTION_TITLE = "activation.settings.general.ga.title.text";
export const GA_SECTION_TITLE_TOOLTIP = "activation.settings.general.ga.title.tooltip";
export const GA_SECTION_ERROR_BANNER_TEXT = "activation.settings.general.ga.error-banner.text";
export const GA_SECTION_FAULTY_MAPPING_BANNER_TEXT = "activation.common.GA.info-banner.mapping-fault-text";
